<template>
    <a href="#" @click.prevent="showSearchForm">
        <img src="/themes/default/img/icons/search.svg"
             alt="search" onload="SVGInject(this);"
        >
    </a>
</template>

<script>
    export default {
        methods: {
            showSearchForm() {
                this.$root.$emit('openSearchForm', true);
            }
        }
    }
</script>
